export const menus = [
    {
        name: 'Trang chủ',
        to: '/',
        exact: true
    },
    {
        name: 'Phim',
        to: '/trang-phim',
        exact: false
    },
    {
        name: 'Kênh TV',
        to: '/livetv',
        exact: false
    },
    {
        name: 'Thể thao',
        to: '/the-thao',
        exact: false
    },
    {
        name: 'TV-Show',
        to: '/tvshow',
        exact: false
    }
];



// WEBPACK FOOTER //
// ./src/menus/index.js